<template>
  <section class="image-cta-counters-module-component">
    <div class="inner-container-with-padding">
      <div class="image-container">
        <img
          :src="props.data.image_cta_image.url"
          alt="Image" />
      </div>
    </div>

    <div class="text-container">
      <div class="background">
        <img
          src="@/assets/img/counter-section-bg.svg"
          alt="Background" />
      </div>
      <div class="content">
        <div
          class="left-content"
          v-html="data.left_side_title" />
        <div class="right-content">
          <div v-html="data.right_side_content" />

          <ArrowCircleButton
            v-if="data.show_button"
            :link="data.button"
            color="white" />
        </div>
      </div>
    </div>

    <div class="cards-container">
      <div
        v-for="(card, idx) in data.cards"
        :key="`card-${idx}`"
        class="cards">
        <BlurBG
          theme="dark"
          :static-bg="idx === 0 ? BGImage : BGImage2"
          :blob-size="1">
          <template #default>
            <div class="card">
              <template v-if="card.show_number">
                <p class="number">
                  ~<span
                    class="numbers"
                    v-html="card.number"></span
                  >K
                </p>
                <div class="divider"></div>
              </template>
              <p
                class="content"
                v-html="card.text"></p>
            </div>
          </template>
        </BlurBG>
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "ImageCTACountersComponent",
  "CLASSNAME": "image-cta-counters-module-component",
  "URL": "http://vuevitewp.local/"
 }
#ENDMETA */

/*
 *   Insert your logic here
 */

const props = defineProps(['data'])
import ArrowCircleButton from '@/components/utility/ArrowCircleButton.vue'
import BlurBG from '../utility/BlurBG.vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { onMounted } from 'vue'
import useUtils from '@/composables/useUtils.js'
import BGImage from '@/assets/img/static_bg_1.svg?url'
import BGImage2 from '@/assets/img/static_bg_2.svg?url'

gsap.registerPlugin(ScrollTrigger)

const { device } = useUtils()

onMounted(() => {
  animateNumbersOnScroll()
})

function animateNumbersOnScroll() {
  const elements = document.querySelectorAll('.numbers')

  elements.forEach((element) => {
    const endValue = parseInt(element.innerText, 10)

    gsap.fromTo(
      element,
      { innerText: 0 },
      {
        innerText: endValue,
        duration: 2,
        ease: 'power1.out',
        scrollTrigger: {
          trigger: element,
          start: `${device.value === 'mobile' ? 'top-=500% center' : 'top-=280% center'}`,
          markers: false,
          onEnter: () => {
            if (!element.classList.contains('animated')) {
              gsap.to(element, {
                innerText: endValue,
                snap: { innerText: 1 },
                duration: 2,
                ease: 'power1.out',
                onUpdate: function () {
                  element.innerText = Math.floor(element.innerText)
                },
                onComplete: function () {
                  element.classList.add('animated')
                },
              })
            }
          },
        },
      }
    )
  })
}
</script>

<style lang="scss">
.image-cta-counters-module-component {
  @apply my-10;
  .image-container {
    @apply px-7 lg:px-lg;

    img {
      @apply h-[350px] w-full object-cover object-top lg:h-[580px];
    }
  }

  .text-container {
    @apply relative bg-bicara-blue pb-[120px] pt-10 lg:pb-[160px] lg:pt-16;

    .background {
      @apply absolute left-0 top-0 h-full w-full overflow-hidden opacity-50;

      img {
        @apply h-full w-full max-w-none object-cover object-center;
      }
    }

    .content {
      @apply inner-container flex flex-col gap-5 px-6 lg:flex-row lg:gap-36 lg:px-12;

      * {
        @apply text-white;
      }

      .left-content {
        @apply header-2 lg:w-1/2 lg:flex-1;

        strong {
          @apply font-light text-bicara-yellow;
        }
      }

      .right-content {
        @apply flex flex-col gap-2 lg:w-1/2 lg:flex-1 lg:pt-2;

        p {
          @apply body-md;
        }
      }
    }
  }

  .cards-container {
    @apply inner-container-with-padding -mt-16 px-lg lg:-mt-32 lg:flex lg:flex-row lg:gap-4 lg:px-lg;

    .cards {
      @apply lg:min-h-[323px] lg:flex-1;

      .card {
        @apply p-5 text-center lg:p-8;

        .number {
          @apply header-2 mb-5 text-[80px] text-bicara-yellow lg:text-[150px];
        }

        .divider {
          @apply mx-auto mb-5 h-[2px] w-full max-w-[260px] bg-bicara-white;
        }

        .content {
          @apply body-lg text-white;
        }
      }
    }
  }
}
</style>
